var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2588 2.40554C12.503 1.86482 11.497 1.86482 10.7412 2.40554L2.9363 7.98915C2.34949 8.40896 2 9.09497 2 9.82703V18.7595C2 20.5492 3.41958 22 5.17073 22H18.8293C20.5804 22 22 20.5492 22 18.7595V9.82703C22 9.09497 21.6505 8.40896 21.0637 7.98915L13.2588 2.40554ZM11.5804 3.63079C11.8323 3.45055 12.1677 3.45055 12.4196 3.63079L20.2245 9.2144C20.4201 9.35434 20.5366 9.58301 20.5366 9.82703V18.7595C20.5366 19.7232 19.7722 20.5044 18.8293 20.5044H5.17073C4.22781 20.5044 3.46341 19.7232 3.46341 18.7595V9.82703C3.46341 9.58301 3.57991 9.35434 3.77552 9.21441L11.5804 3.63079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.cc5f97197356546cf629d6278ffdc9d4.svg";
export { ForwardRef as ReactComponent };